module.exports = __webpack_public_path__ + "static/img/4.c03b06a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/zh/4.png
// module id = 7Hzz
// module chunks = 0